                          const now = new Date();
  const currentDay = now.getDay();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  let storeOpen = true;
  if (currentDay >= 0 && currentDay <= 6 &&
      currentHour >= 10 && (currentHour < 21 || (currentHour === 21 && currentMinute <= 30))) {
  } else {
    storeOpen = false;
  }
                        if (storeOpen) {
  document.querySelectorAll(".isClosed").forEach((element) => {
    element.style.display = "none";
    if (element.nextElementSibling) {
      element.nextElementSibling.style.display = "none";
    }
  });

  document.querySelectorAll(".isOpen").forEach((element) => {
    element.style.display = "block";
    if (element.nextElementSibling) {
      element.nextElementSibling.style.display = "block";
    }
  });
     document.querySelectorAll(".from-and-to-closeat").forEach((element) => {
    element.style.display = "block";
  });  
           document.querySelectorAll(".from-and-to-openat").forEach((element) => {
    element.style.display = "none";
  }); 
} else {
  document.querySelectorAll(".isOpen").forEach((element) => {
    element.style.display = "none";
    if (element.nextElementSibling) {
      element.nextElementSibling.style.display = "none";
    }
  });

  document.querySelectorAll(".isClosed").forEach((element) => {
    element.style.display = "block";
    if (element.nextElementSibling) {
      element.nextElementSibling.style.display = "block";
    }
  });
                           document.querySelectorAll(".from-and-to-closeat").forEach((element) => {
    element.style.display = "none";
  });  
           document.querySelectorAll(".from-and-to-openat").forEach((element) => {
    element.style.display = "block";
  }); 
}

// ========================= open city accordian ===============================
function closeAllCityAccordions() {
  var items = document.getElementsByClassName("city-accordion");
  for (var j = 0; j < items.length; j++) {
    items[j].classList.remove("city-active");
    var p = items[j].nextElementSibling;
    if (p) {
      p.style.maxHeight = null;
    }
  }
}

var acc = document.getElementsByClassName("city-accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function (e) {
    e.stopPropagation();
    this.classList.toggle("city-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = "300px";
    }
  });
}

document.addEventListener("click", function (e) {
  var t = e.target;
  if (t instanceof Element && !t.closest(".custom-select-city")) {
    closeAllCityAccordions();
  }
});
                     
       

                  // ================================  Pop up Image swiper code ============================== 
                  
                  var swiper = new Swiper(".customSwiperMap", {
                     slidesPerView: 1.3,
      spaceBetween: 10,
                      navigation: {
        nextEl: ".customSwiperMap .swiper-button-next",
        prevEl: ".customSwiperMap .swiper-button-prev",
      },
        mousewheel: false,
                     breakpoints: {
    650: {
      slidesPerView: 2.55,
      spaceBetween: 20, // Optional: Adjust spacing for smaller screens
    },
  },
    
                    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
                   
    });

                
                  function filterStoreInPresentLocation(elem) {
  const clickedData = elem.getAttribute("data-value");
  const activeElement = document.querySelector(".store_filter_title.active");                  
  const serviceTypeSelect = document.querySelectorAll(".store-item.service_type_select");
  serviceTypeSelect.forEach((selectst) => {
    const serviceType = selectst.getAttribute("select-service");
    const servicesArray = serviceType.split(",").map(service => service.trim());
    if (servicesArray.includes(clickedData)) {
      selectst.style.display = "block";
    } else {
      selectst.style.display = "none";
    }
  });
                     if (activeElement) {
    activeElement.classList.remove("active");
  }
  elem.classList.add("active");
}

                  
    
                  let swiper1 = new Swiper(".myCustomerSwiper", {
  slidesPerView: 1.3,
  spaceBetween: 20,
  freeMode: true,
  mousewheel: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    750: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});


                
const otherStoresSliderEl = document.querySelector(".store-locator-main-wrapper_slider");
if (otherStoresSliderEl) {
  let swiperStoreCard = new Swiper(".store-locator-main-wrapper_slider", {
    slidesPerView: 1.3,
    spaceBetween: 14,
    freeMode: true,
    mousewheel: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      650: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 20,
      },
    },
  });
}

